import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-web-development',
  imports: [RouterLink],
  templateUrl: './web-development.html',
  styleUrl: '../service-pages.scss',
})
export class WebDevelopment {}
